import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { HintText } from 'components/HintText/HintText';
import { HINTTEXT_TYPE } from 'components/HintText/HintTextType';

import './FormActionButtons.sass';

export const FormActionButtons = ({
  hasErrors,
  titleLeft,
  titleRight,
  onClickLeft,
  onClickRight,
  errorMessage,
  loading,
}) => {
  return (
    <>
      {hasErrors && errorMessage && (
        <div className="form-action-buttons__error-hint">
          <HintText type={HINTTEXT_TYPE.ERROR}>{errorMessage}</HintText>
        </div>
      )}
      <div className="form-action-buttons__buttons-wrap">
        <ActionButton
          loading={loading}
          inverted
          onClick={onClickLeft}
          type="button"
          title={titleLeft}
          disabled={loading}
        />
        <ActionButton
          loading={loading}
          inverted
          onClick={onClickRight}
          type="submit"
          title={titleRight}
          disabled={hasErrors}
        />
      </div>
    </>
  );
};

FormActionButtons.propTypes = {
  hasErrors: PropTypes.bool,
  titleLeft: PropTypes.string.isRequired,
  titleRight: PropTypes.string.isRequired,
  onClickLeft: PropTypes.func.isRequired,
  onClickRight: PropTypes.func.isRequired,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  loading: PropTypes.bool,
};

FormActionButtons.displayName = 'FormActionButtons';

FormActionButtons.defaultProps = {
  hasErrors: false,
  errorMessage: '',
  loading: false,
};
